import React from 'react'
import Icon from './icon'

const Plus = ({
  viewBox = '0 0 24 24',
  style = { fill: '#e3e3e3', height: 200, width: 200 }
}) => {
  return (
    <Icon viewBox={viewBox} style={style}>
      <path d="M13,7h-2v4H7v2h4v4h2v-4h4v-2h-4V7z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20 c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z" />
    </Icon>
  )
}

export default Plus



// WEBPACK FOOTER //
// ./src/components/Icons/plus.js